module.exports = __webpack_public_path__ + "img/support.6b822dd0.png";